import DriveCard from "../ui/DriveCard.jsx";

// Storage: today's Google Drive connection, moved here from the everyday app.
export default function Storage() {
  return (
    <section>
      <h1>التخزين</h1>
      <DriveCard />
    </section>
  );
}
